export const eventBus = {
	callbacks: {},
	on( event, callback ) {
		if ( ! this.callbacks[ event ] ) {
			this.callbacks[ event ] = [];
		}
		const id = Symbol();
		this.callbacks[ event ].push( { id, callback } );
		return id;
	},
	off( event, id ) {
		if ( this.callbacks[ event ] ) {
			this.callbacks[ event ] = this.callbacks[ event ].filter(
				( item ) => item.id !== id
			);
		}
	},
	emit( event, data ) {
		if ( this.callbacks[ event ] ) {
			this.callbacks[ event ].forEach( ( callback ) => {
				callback.callback( data );
			} );
		}
	},
};
